export const ADD_SPEECH_RATE: string = 'ADD_SPEECH_RATE';
export const CLEAR_SPEECH_RATES: string = 'CLEAR_SPEECH_RATES';

export function addSpeechRate(
	rateKey: string,
	rateVal: string
): IAddSpeechRateActionType {
	return { type: ADD_SPEECH_RATE, rateKey: rateKey, rateVal: rateVal };
}
export function clearSpeechRates(): IClearSpeechRateActionType {
	return { type: CLEAR_SPEECH_RATES };
}

interface IAddSpeechRateActionType {
	type: string;
	rateKey: string;
	rateVal: string;
}

interface IClearSpeechRateActionType {
	type: string;
}
